/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Win_Back_Paywall_Benefit_Exclusive_ContentInputs */

const en_win_back_paywall_benefit_exclusive_content = /** @type {(inputs: Win_Back_Paywall_Benefit_Exclusive_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus-exclusive trees`)
};

const ar_win_back_paywall_benefit_exclusive_content = /** @type {(inputs: Win_Back_Paywall_Benefit_Exclusive_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أشجار حصرية لمشتركي Plus`)
};

const de_win_back_paywall_benefit_exclusive_content = /** @type {(inputs: Win_Back_Paywall_Benefit_Exclusive_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exklusive Plus-Bäume`)
};

const es_win_back_paywall_benefit_exclusive_content = /** @type {(inputs: Win_Back_Paywall_Benefit_Exclusive_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Árboles exclusivos de Plus`)
};

const fr_win_back_paywall_benefit_exclusive_content = /** @type {(inputs: Win_Back_Paywall_Benefit_Exclusive_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arbres exclusifs à Plus`)
};

const it_win_back_paywall_benefit_exclusive_content = /** @type {(inputs: Win_Back_Paywall_Benefit_Exclusive_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alberi esclusivi di Plus`)
};

const ja_win_back_paywall_benefit_exclusive_content = /** @type {(inputs: Win_Back_Paywall_Benefit_Exclusive_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus限定の樹種`)
};

const ko_win_back_paywall_benefit_exclusive_content = /** @type {(inputs: Win_Back_Paywall_Benefit_Exclusive_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus 전용 나무`)
};

const pt_br_win_back_paywall_benefit_exclusive_content = /** @type {(inputs: Win_Back_Paywall_Benefit_Exclusive_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Árvores exclusivas do Plus`)
};

const ru_win_back_paywall_benefit_exclusive_content = /** @type {(inputs: Win_Back_Paywall_Benefit_Exclusive_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Эксклюзивные деревья Plus`)
};

const th_win_back_paywall_benefit_exclusive_content = /** @type {(inputs: Win_Back_Paywall_Benefit_Exclusive_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ต้นไม้เฉพาะสมาชิก Plus`)
};

const tr_win_back_paywall_benefit_exclusive_content = /** @type {(inputs: Win_Back_Paywall_Benefit_Exclusive_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus'a özel ağaçlar`)
};

const zh_cn_win_back_paywall_benefit_exclusive_content = /** @type {(inputs: Win_Back_Paywall_Benefit_Exclusive_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus 专属树种`)
};

const zh_tw_win_back_paywall_benefit_exclusive_content = /** @type {(inputs: Win_Back_Paywall_Benefit_Exclusive_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus 專屬樹種`)
};

/**
* | output |
* | --- |
* | "Plus-exclusive trees" |
*
* @param {Win_Back_Paywall_Benefit_Exclusive_ContentInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const win_back_paywall_benefit_exclusive_content = /** @type {((inputs?: Win_Back_Paywall_Benefit_Exclusive_ContentInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Win_Back_Paywall_Benefit_Exclusive_ContentInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_win_back_paywall_benefit_exclusive_content(inputs)
	if (locale === "ar") return ar_win_back_paywall_benefit_exclusive_content(inputs)
	if (locale === "de") return de_win_back_paywall_benefit_exclusive_content(inputs)
	if (locale === "es") return es_win_back_paywall_benefit_exclusive_content(inputs)
	if (locale === "fr") return fr_win_back_paywall_benefit_exclusive_content(inputs)
	if (locale === "it") return it_win_back_paywall_benefit_exclusive_content(inputs)
	if (locale === "ja") return ja_win_back_paywall_benefit_exclusive_content(inputs)
	if (locale === "ko") return ko_win_back_paywall_benefit_exclusive_content(inputs)
	if (locale === "pt_br") return pt_br_win_back_paywall_benefit_exclusive_content(inputs)
	if (locale === "ru") return ru_win_back_paywall_benefit_exclusive_content(inputs)
	if (locale === "th") return th_win_back_paywall_benefit_exclusive_content(inputs)
	if (locale === "tr") return tr_win_back_paywall_benefit_exclusive_content(inputs)
	if (locale === "zh_cn") return zh_cn_win_back_paywall_benefit_exclusive_content(inputs)
	return zh_tw_win_back_paywall_benefit_exclusive_content(inputs)
});